import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.scss'],
    standalone: false
})
export class DialogConfirmComponent implements OnInit {


  @Input() public message: string = 'Are you sure you want to proceed?';

 // Inject the active modal reference
  constructor(public activeModal: NgbActiveModal) {}

  onConfirm(): void {
    // Use 'close()' to resolve the result promise with 'true'
    this.activeModal.close(true);
  }

  onCancel(): void {
    // Use 'dismiss()' to reject the result promise with 'false'
    this.activeModal.dismiss(false);
  }
  ngOnInit() {
  }

}
